module.exports = __webpack_public_path__ + "static/img/defult.7d2c6aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/logo/defult.png
// module id = QgSW
// module chunks = 1